import { render, staticRenderFns } from "./thirds_config_list.vue?vue&type=template&id=7b8610fe"
import script from "./thirds_config_list.vue?vue&type=script&lang=js"
export * from "./thirds_config_list.vue?vue&type=script&lang=js"
import style0 from "./thirds_config_list.vue?vue&type=style&index=0&id=7b8610fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports